<template>
  <div>
    <div
      class="card-title card-title-flex"
      @click="show=true"
    >
      <div>{{ title }}</div>
      <div class="card-title-info">
        <span>{{ currentSelected.name }}</span>
        <van-icon name="arrow" />
      </div>
    </div>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      @select="onSelect"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: undefined
    },
    dataList: {
      type: Array,
      required: true
    },
    value: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      show: false,
      actions: [],
      currentSelected: {}
    };
  },
  watch: {
    value() {
      this.getActions();
    },
    dataList() {
      this.getActions();
    }
  },
  mounted() {
    this.getActions();
  },
  methods: {
    getActions() {
      this.actions = this.dataList.map(item => ({ ...item, name: item.value }));
      this.currentSelected = this.actions.find(item => item.key === this.value) || {};
    },
    onSelect(item) {
      console.log('item', item);
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.currentSelected = item;
      this.$emit('update:value', item.value);
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.select-box{
  display: flex;
  flex-wrap: wrap;

  margin: 16px 0 -10px -10px;
  .select-item {
    min-width: 30px;
    margin: 0 0 10px 10px;
    padding: 5px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    color: #646464;
    border-radius: 4px;
    background: #E1E7ED;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.active{
      color: #ffffff;
      background: #3399FF;
    }
  }
}
</style>
